import React from "react";

import { Button } from "components/Button";

export const Pagination = ({ currentPage, totalPages, onPageChange, start, end, total }) => {
  const handleClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  // Render pagination for mobile view
  const renderMobilePagination = () => (
    <div className="flex justify-between sm:hidden">
      <Button onClick={() => handleClick(currentPage - 1)} disabled={currentPage === 1} color="secondary" size="sm">
        Prev
      </Button>
      <Button color="secondary" size="sm" onClick={() => handleClick(currentPage + 1)} disabled={currentPage === totalPages}>
        Next
      </Button>
    </div>
  );

  // Render pagination for tablet/desktop view
  const renderTabletPagination = () => {
    // Define number of pages to show around current page
    const numPagesToShow = 3;
    const startPage = Math.max(1, currentPage - numPagesToShow);
    const endPage = Math.min(totalPages, currentPage + numPagesToShow);

    // Generate array of page numbers to display
    const pages = [...Array(endPage - startPage + 1).keys()].map((i) => startPage + i);

    return (
      <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
        <div>
          <p className="text-sm text-gray-700">
            Showing <span className="font-medium">{start}</span> to <span className="font-medium">{end}</span> of <span className="font-medium">{total}</span> results
          </p>
        </div>
        <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm">
          <button
            role="link"
            onClick={() => handleClick(currentPage - 1)}
            disabled={currentPage === 1}
            className="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
          >
            <span className="sr-only">Previous</span>
            <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path
                fillRule="evenodd"
                d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
                clipRule="evenodd"
              ></path>
            </svg>
          </button>
          {startPage > 1 && <span className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-700 ring-1 ring-inset ring-gray-300 focus:outline-offset-0">...</span>}
          {pages.map((page) => (
            <button
              role="link"
              key={page}
              onClick={() => handleClick(page)}
              className={`${
                currentPage === page
                  ? "relative z-10 inline-flex items-center bg-indigo-600 px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  : "relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
              }`}
            >
              {page}
            </button>
          ))}
          {endPage < totalPages && <span className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-700 ring-1 ring-inset ring-gray-300 focus:outline-offset-0">...</span>}

          <button
            role="link"
            onClick={() => handleClick(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
          >
            <span className="sr-only">Next</span>
            <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path
                fillRule="evenodd"
                d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                clipRule="evenodd"
              ></path>
            </svg>
          </button>
        </nav>
      </div>
    );
  };

  return (
    <div className="mt-4">
      {renderMobilePagination()}
      <div className="hidden md:block">{renderTabletPagination()}</div>
    </div>
  );
};
